export async function encryptData(data: object, keyHex: string): Promise<string> {
  // Helper to convert hex string to Uint8Array
  function hexStringToUint8Array(hexString: string): Uint8Array {
    if (hexString.length % 2 !== 0) {
      throw new Error("Invalid hex string");
    }
    const array = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
      array[i / 2] = parseInt(hexString.substr(i, 2), 16);
    }
    return array;
  }

  const encoder = new TextEncoder();
  const encodedData = encoder.encode(JSON.stringify(data));
  const iv = window.crypto.getRandomValues(new Uint8Array(12)); 

  const keyBuffer = hexStringToUint8Array(keyHex);
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv,
      tagLength: 128,
    },
    cryptoKey,
    encodedData
  );

  const encryptedBytes = new Uint8Array(encryptedBuffer);

  const ciphertext = encryptedBytes.slice(0, encryptedBytes.length - 16); 
  const authTag = encryptedBytes.slice(encryptedBytes.length - 16); 

  const ivBase64 = btoa(String.fromCharCode(...iv));
  const ciphertextBase64 = btoa(String.fromCharCode(...ciphertext));
  const authTagBase64 = btoa(String.fromCharCode(...authTag));

  return `${ivBase64}:${ciphertextBase64}:${authTagBase64}`;
}
